import { motion } from "framer-motion";
import { Button } from "../ui/button";
import { ChevronRight, Wifi } from "lucide-react";
import { useWhatsApp } from "../../context/WhatsAppContext";

export default function CtaSection() {
  const { openWhatsAppModal } = useWhatsApp();
  return (
    <section className="py-20 lg:py-28 relative overflow-hidden">
      <div className="absolute inset-0 gradient-violet opacity-10" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-primary/5 blur-3xl" />

      <div className="relative z-10 max-w-3xl mx-auto px-4 sm:px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="h-16 w-16 rounded-2xl bg-primary flex items-center justify-center mx-auto mb-8 animate-float"> {/* Atualizado para usar cor cheia */}
            <Wifi className="h-12 w-12 text-white" />
          </div>

          <h2 className="font-poppins font-bold text-3xl sm:text-4xl lg:text-5xl text-foreground mb-6 leading-tight">
            Contrate agora e<br />
            <span className="text-primary">navegue sem limites</span>
          </h2>

          <p className="text-lg text-muted-foreground mb-10 max-w-xl mx-auto leading-relaxed">
            Internet fibra óptica de verdade com instalação grátis, sem fidelidade e com o melhor suporte da região.
          </p>

          <button onClick={openWhatsAppModal}>
            <Button
              size="lg"
              className="bg-success hover:bg-success/90 text-white font-bold text-lg px-10 py-7 glow-green"
            >
              Falar no WhatsApp
            </Button>
          </button>

          <p className="text-sm text-muted-foreground mt-6">
            Atendimento rápido • Sem burocracia
          </p>
        </motion.div>
      </div>
    </section>
  );
}